import { default as Utils } from '../utils/base.Utils.js';
import { default as Errors } from '../errors/base.Errors.js';
import 'whatwg-fetch';
export default class ServicesBase {

  constructor() {

  }

  //set the header for language and authentication
  static setCommonHeaders(headers) {
    headers.append('MobileCode', Utils.Cookie.get('MobileCode'));
    headers.append('culture', Utils.Language.getUserLanguage());
    headers.append('UIculture', Utils.Language.getUserLanguage());
    if(Utils.Cookie.get("jwttoken")) {
      headers.append('JWTToken', Utils.Cookie.get("jwttoken"));
    } else {
      headers.append('CustomerToken', Utils.Cookie.get("CustomerToken"));
    }
  }

  //make the call using fetch and return a promise
  static async doTheCall(jsonData, params, waiter) {//type, url, waiter, contentType, dataType, authenticated, download) {
 
    waiter = waiter != false ? (waiter ? waiter : 'body') : null;

    let spinner;
    if (waiter) {
      spinner = new Utils.Spinner();
      spinner.spin(waiter);
    }

    let contentType = params.contentType == undefined ? 'application/json; charset=utf-8' : params.contentType;  
    let authenticated = params.authenticated == undefined ? true : params.authenticated;

    //let dataType = params.dataType == undefined ? 'json' : params.dataType == undefined;
    let dataType = params.dataType == undefined ? 'json' : params.dataType; 

    let myHeaders = new Headers();
    myHeaders.append('Content-Type', contentType);

    if (authenticated)
       ServicesBase.setCommonHeaders(myHeaders);
    myHeaders.delete('Cookie');
    let options = {
      headers: myHeaders,
      method: params.type,
      // mode: 'cors',
      body: !jsonData ? undefined : jsonData
    };

    try {
      let response = await fetch(params.url, options);
      let data;
      switch (dataType) {
        case 'json':        
          data = await response.json();
          break;
        case 'text':       
          data = await response.text();
          break;
        case 'blob':        
          data = await response.blob();
          break;  
        case 'excel':
          data = {};
          data.blob = await response.blob();
          data.filename = response.headers.get("content-disposition");
          break;
      }

      if (waiter && spinner)
        spinner.stop();

      if (response.status === 403)
        window.location.href.replace("index", "login");

      return response.ok ? data : Promise.reject(data);

    } catch (err) {

      if (waiter && spinner)
        spinner.stop();

      return Promise.reject(new Errors.Custom(Errors.Types.SERVICE_ERROR, err.message));
    }
  }
}
